const intensity = [
  { label: "Light", value: "1" },
  { label: "Moderate", value: "2" },
  { label: "High", value: "3" },
  { label: "Very High", value: "4" },
];

export default intensity;